// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'payback', 'payback Fallback'"},"className":"__className_9d7325","variable":"__variable_9d7325"};